exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat+Alternates);", ""]);

// module
exports.push([module.id, ".doc-flex[data-v-1274da11]{display:flex;flex-direction:column;width:100%;height:100%;border-radius:5px;margin-top:5px;margin-bottom:10px;text-align:left;padding:15px;box-shadow:0 .5px 2px .5px #555;transition:all .15s ease;-webkit-transition:all .15s ease;-moz-transition:all .15s ease;-o-transition:all .15s ease}.doc-flex[data-v-1274da11]:hover{transform:scale(1.005);box-shadow:0 2.25px 2.3px 1.5px rgba(85,85,85,.75)}.title[data-v-1274da11]{padding-top:2.5px;padding-bottom:2.5px;margin:0}.doc-description[data-v-1274da11]{font-size:13pt;color:#4a148c}.doc-party[data-v-1274da11]{font-size:11pt;padding-bottom:5px}.date[data-v-1274da11]{font-size:11pt}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1274da11","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Documents.vue
// module id = 51
// module chunks = 0